import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Attach admin token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hm_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const WHATSAPP_NUMBER = "40741142142";
export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg || "Bună ziua! Doresc informații despre un tur la Habitatul Meu Bird & Wildlife Park.")}`;

export function formatErr(detail) {
  if (!detail) return "A apărut o eroare. Încearcă din nou.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}
